export default {
  UPDATE_COUNTRY_AND_STATE_INFORMATION: 'once:tax-form:update-country-state',
  SHOW_TAX_INFORMATION: 'once:tax-form:show-information',
  VALIDATE_TAX_FORM: 'once:tax-form:validate',
  VALIDATE_TAX_FORM_RESULT: 'once:tax-form:validate-result',
  TAX_DETAILS_UPDATE: 'tax-details:updated',
  SHOW_VERIFY_MOBILE: 'once:verify-mobile:show',
  HIDE_VERIFY_MOBILE: 'once:verify-mobile:hide',
  CLEAR_MOBILE_PHONE: 'once:edit-profile:clear-phone',
  SHOW_2FA_CODE_AFTER_MOBILE_VERIFED:
    'once:edit-profile:mobile-verified:show-2fa-code',
  VERIFIED_PHONE_MOBILE_SUCCESSFUL:
    'once:edit-profile:mobile-verified:success-verified',
  CHECKOUT_DETAIL_STEP: 'once:checkout:detail-step',
  CHECKOUT_DETAIL_STEP_UNMOUNTED: 'once:checkout:detail-step:unmounted',
  SHOW_SWITCH_TO_MONTHLY_MODAL: 'once:switch_to_monthly_modal:show',
  SHOW_PURCHASE_ADDITIONAL_USERS_MODAL:
    'once:purchase_additional_users_modal:show',
  SHOW_RENEW_ANNUAL_PLAN_MODAL: 'once:renew_annual_plan_modal:show',
  SHOW_CANCEL_SUBSCRIPTION_MODAL: 'once:cancel_subscription_modal:show',
  SHOW_CHOOSE_PLAN_MODAL: 'once:choose_plan_modal:show',
  HIDE_CHOOSE_PLAN_MODAL: 'once:choose_plan_modal:hide',
  RESET_PLAN_OPTIONS: 'once:reset_plan_options',
  SHOW_SUBSCRIPTION_OPTIONS: 'once:show_subscription_options:open',
  HIDE_SUBSCRIPTION_OPTIONS: 'once:hide_subscription_options:close',
  SUBSCRIPTION_LOADED: 'once:subscription:loaded',
  EDIT_ORGANIZATION_TAB_CHANGED: 'once:edit-organization:tab-changed',
  BUSINESS_SETTINGS: 'once:business:settings',
  OPEN_BILLING_CONTACT_MODAL: 'once:open-billing-contact-modal',
  OPEN_COMPANY_CONTACT_MODAL: 'once:open-company-contact-modal',
};
